const url = `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUD_NAME_CLOUDINARY}/image/upload`;
console.log('Cloudinary URL:', url); 

const uploadImage = async (image) => {
  if (!image) return null;

  const formData = new FormData();
  formData.append("file", image);
  formData.append("upload_preset", "fashionfy");

  try {
    const response = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const data = await response.json();

    if (!response.ok) {
      console.error("Cloudinary upload error:", data);
      return null;
    }

    return data; // contains data.secure_url
  } catch (error) {
    console.error("Cloudinary fetch error:", error);
    return null;
  }
};


export default uploadImage;
